/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Form_Aria_LabelInputs */

const en_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Project Form`)
};

const fr_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de nouveau projet`)
};

const de_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Projektformular`)
};

const it_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo modulo di progetto`)
};

const ru_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма нового проекта`)
};

const es_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de nuevo proyecto`)
};

const zh_cn2_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新项目表格`)
};

const ja_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいプロジェクトフォーム`)
};

const hi_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया प्रोजेक्ट फॉर्म`)
};

const pt_pt2_new_project_form_aria_label = /** @type {(inputs: New_Project_Form_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário para Novo Projeto`)
};

/**
* | output |
* | --- |
* | "New Project Form" |
*
* @param {New_Project_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_form_aria_label = /** @type {((inputs?: New_Project_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_form_aria_label(inputs)
	if (locale === "de") return de_new_project_form_aria_label(inputs)
	if (locale === "it") return it_new_project_form_aria_label(inputs)
	if (locale === "ru") return ru_new_project_form_aria_label(inputs)
	if (locale === "es") return es_new_project_form_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_form_aria_label(inputs)
	if (locale === "ja") return ja_new_project_form_aria_label(inputs)
	if (locale === "hi") return hi_new_project_form_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_form_aria_label(inputs)
	return en_new_project_form_aria_label(inputs)
});